import React from "react";

/**
 * ErrorBoundary: captura exceções em qualquer filho e mostra uma tela amigável
 * em vez de derrubar a aplicação inteira (tela preta).
 * Zero custo em operação normal — só age quando há erro.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Log discreto; não quebra se o console estiver desabilitado
    try { console.error("[ErrorBoundary]", error, info?.componentStack); } catch {}
  }

  handleReload = () => {
    try { this.setState({ error: null }); } catch {}
    try { window.location.reload(); } catch {}
  };

  handleBack = () => {
    try { this.setState({ error: null }); } catch {}
    try { window.history.back(); } catch {}
  };

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    const message = (error && (error.message || String(error))) || "Erro inesperado";

    return (
      <div style={{
        minHeight: "100dvh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#FAFAFA",
        padding: "24px",
        fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
      }}>
        <div style={{
          maxWidth: "440px",
          background: "#FFFFFF",
          border: "1px solid #E5E5E5",
          borderRadius: "12px",
          padding: "28px",
          textAlign: "center",
          color: "#0A0A0A",
          boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
        }}>
          <div style={{
            width: "44px",
            height: "44px",
            borderRadius: "999px",
            background: "#FEE2E2",
            color: "#B91C1C",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: "24px",
            fontWeight: 600,
            marginBottom: "14px",
          }}>!</div>
          <h1 style={{ fontSize: "18px", fontWeight: 700, margin: "0 0 6px" }}>
            Algo deu errado ao carregar esta tela
          </h1>
          <p style={{ fontSize: "13px", color: "#6B7280", margin: "0 0 18px" }}>
            Sua sessão está segura. Você pode voltar ou recarregar a página.
          </p>
          <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
            <button onClick={this.handleBack} style={{
              padding: "8px 16px",
              borderRadius: "8px",
              border: "1px solid #E5E5E5",
              background: "#FFFFFF",
              color: "#0A0A0A",
              cursor: "pointer",
              fontSize: "13px",
            }}>Voltar</button>
            <button onClick={this.handleReload} style={{
              padding: "8px 16px",
              borderRadius: "8px",
              border: "1px solid #0A0A0A",
              background: "#0A0A0A",
              color: "#FFFFFF",
              cursor: "pointer",
              fontSize: "13px",
            }}>Recarregar</button>
          </div>
          {/* Detalhe técnico recolhido — útil se o usuário quiser reportar */}
          <details style={{ marginTop: "18px", textAlign: "left" }}>
            <summary style={{ fontSize: "11px", color: "#9CA3AF", cursor: "pointer" }}>
              Detalhes técnicos
            </summary>
            <pre style={{
              fontSize: "10px",
              color: "#6B7280",
              background: "#F9FAFB",
              padding: "8px",
              borderRadius: "6px",
              marginTop: "6px",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
            }}>{message}</pre>
          </details>
        </div>
      </div>
    );
  }
}
